import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress'


export const DeleteDialog = ({handleClose, confirmDelete, isLoading}) => {
	const { t } = useTranslation()
    return(
		<Dialog
			open={open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
      	>
			<DialogTitle id="alert-dialog-title">{t('Confirm-delete-parcel.Title')}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
					{t('Confirm-delete-parcel.Body')}
					</DialogContentText>
				</DialogContent>
			<DialogActions>
				<Button onClick={()=>{handleClose()}} color="primary">
					{t('Cancel')}
				</Button>
				<Button onClick={()=> {confirmDelete()}} color="primary" autoFocus>
					{isLoading ? (
						<CircularProgress
							color="inherit"
							size={20}
						/> 
						) : (
							t('Delete')
						)
					}
				</Button>
			</DialogActions>
		</Dialog>
    )
}